import Chip from '@material-ui/core/Chip';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import withFormikFieldArray from '../withFormikFieldArray';


const withSelectPills = (SelectComponent) => {
   const InnerWithSelectPills = (props) => {
      const [selectValue, setSelectValue] = useState('');
      const [selectedIdList, setSelectedIdList] = useState([]);

      useEffect(() => {
         if (props.value) {
            setSelectedIdList(props.value.map(({ id }) => id));
         }
      }, [JSON.stringify(props.value)]);

      const handleChangeSelect = useCallback((option, arg = { action: undefined }) => {
         if (arg?.action === 'select-option') {
            setSelectValue(null);
            if (selectedIdList.includes(option?.id)) {
               const indexToRemove = lodash.isArray(props.value) && props.value.findIndex(({id}) => +(option?.id) === +id);
               if (!Number.isNaN(indexToRemove)) {
                  props.remove(indexToRemove);
               }
            } else {
               props.push(option);
            }
         } else {
            setSelectValue(option);
         }
      }, [props.push, selectedIdList, props.value]);

      return (
         <div>
            <SelectComponent
               onChange={handleChangeSelect}
               handleBlur={props.handleBlur}
               value={selectValue}
               isSearchable
               isOptionSelected={(option) => {
                  return selectedIdList.includes(option?.id);
               }}
            />
            <div>
               {
                  lodash.isArray(props.value)
                  && (
                     props.value.map((item, idxItem) => {
                        return (
                           <div
                              className='my-1'
                              key={`${ item.id }`}
                           >
                              <Chip
                                 clickable
                                 size='small'
                                 label={item?.name}
                                 onDelete={() => {
                                    props.remove(idxItem);
                                 }}
                              />
                           </div>
                        );
                     })
                  )
               }
            </div>
         </div>
      );
   };

   InnerWithSelectPills.propTypes = {
      value: PropTypes.arrayOf(PropTypes.shape({
         id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
         name: PropTypes.string.isRequired,
      })).isRequired,
      push: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
      handleBlur: PropTypes.func.isRequired,
   };

   InnerWithSelectPills.defaultProps = {
   };

   return InnerWithSelectPills;
};

export default (SelectComponent) => withFormikFieldArray(withSelectPills(SelectComponent));
